import React from 'react'
import {useSnackbar} from 'notistack'
import {useTranslation} from 'react-i18next'

import {AttachEstimate} from '../../../../../../components/AttachEstimate'
import {useTracFloSelector} from '../../../../../../store/useTracFloSelector'
import {
  attachEstimateToChangeOrder, 
  AttachEstimateToChangeOrderOutput, 
  removeEstimateFromChangeOrder
} from '../../../../../../api/changeOrder'


export type ChangeOrderAttachedEstimateProps = {
  coId: string,
  estimate_id: string | null,
  attachEstimate: (output: AttachEstimateToChangeOrderOutput) => void,
  removeEstimate: () => void,
}

export function ChangeOrderAttachEstimate(
  {estimate_id, coId, attachEstimate, removeEstimate}: ChangeOrderAttachedEstimateProps
): JSX.Element {
  const {t} = useTranslation('private')
  const {enqueueSnackbar} = useSnackbar()
  const project = useTracFloSelector((state) => state.project)

  const attachEstimateFromComponent = async (estimateId: string) => {
    try {
      const res = await attachEstimateToChangeOrder(project.id, coId, estimateId)
      if (res.status !== 200 || !res.data.estimate_id) {
        enqueueSnackbar(t('view.ChangeOrder.Summary.ChangeOrderAttachEstimate.attachFail'), {variant: 'error'})
        return
      }
      enqueueSnackbar(t('view.ChangeOrder.Summary.ChangeOrderAttachEstimate.attachSuccess'), {variant: 'success'})
      attachEstimate(res.data)
    } catch (_) {
      enqueueSnackbar(t('view.ChangeOrder.Summary.ChangeOrderAttachEstimate.attachFail'), {variant: 'error'})
    }
  }

  const removeEstimateFromComponent = async () => {
    try {
      const res = await removeEstimateFromChangeOrder(project.id, coId)
      if (res.status !== 200) {
        enqueueSnackbar(t('view.ChangeOrder.Summary.ChangeOrderAttachEstimate.removeFail'), {variant: 'error'})
        return
      }
      enqueueSnackbar(t('view.ChangeOrder.Summary.ChangeOrderAttachEstimate.removeSuccess'), {variant: 'success'})
      removeEstimate()
    } catch (_) {
      enqueueSnackbar(t('view.ChangeOrder.Summary.ChangeOrderAttachEstimate.removeFail'), {variant: 'error'})
    }
  }

  return (
    <AttachEstimate
      estimate_id={estimate_id}
      attachNewEstimate={attachEstimateFromComponent}
      removeEstimate={removeEstimateFromComponent}
    />
  )
}

